var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 50,
    viewBox: "0 0 294 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293 4H293.5V3.5H293V4ZM293 49V49.5H293.5V49H293ZM1 49H0.5V49.5H1V49ZM1 4V3.5H0.5V4H1ZM256.375 4.35355C256.57 4.15829 256.57 3.84171 256.375 3.64645L253.193 0.464466C252.997 0.269204 252.681 0.269204 252.486 0.464466C252.29 0.659728 252.29 0.976311 252.486 1.17157L255.314 4L252.486 6.82843C252.29 7.02369 252.29 7.34027 252.486 7.53553C252.681 7.7308 252.997 7.7308 253.193 7.53553L256.375 4.35355ZM292.5 4V49H293.5V4H292.5ZM293 48.5H1V49.5H293V48.5ZM1.5 49V4H0.5V49H1.5ZM1 4.5H160.078V3.5H1V4.5ZM160.078 4.5H256.021V3.5H160.078V4.5ZM272.549 4.5H293V3.5H272.549V4.5Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.a61dd80d.svg";
export { ForwardRef as ReactComponent };